// pages/NotFound.jsx
const NotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404</h1>
      <p>Page not found</p>
    </div>
  );
};

export default NotFound;
